import {LeafletMap} from "./map_leaflet";
import {LeafletMapEdit} from "./map_leaflet_edit";

/**
 * Create Leaflet layer from OSM
 * @alias Ptx.maps.OSM.defineMap
 * @param code
 * @param constructor
 * @param serverBase may be undefined
 */
export function defineMap(code, constructor, serverBase) {
	var attribution = 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>';
	var baseServer = 'https://osm.levelna.cz/tiles/##STATE##/{z}/{x}/{y}.png';
	if (typeof serverBase !== 'undefined') {
		baseServer = serverBase;
	}
	
	return constructor(baseServer.replace("##STATE##", code), {
		maxZoom: 18,
		attribution: attribution
	});
}

/**
 * Leaflet layer definition from one code
 */
function oneLayer(code, serverBase) {
	var l = [], obj = {};
	l.push(defineMap(code, L.tileLayer, serverBase));
	obj["code"] = code;
	obj["serverBase"] = serverBase;
	obj["layers"] = l;
	return obj;
}

function OSMczsk() {return oneLayer("cz-sk")}
function OSMworld() {return oneLayer("osmbright")} // whole world map

/**
 * Map definitions for map types
 */

/**
 * @alias Ptx.maps.OSM_CZSK
 */
export const LeafletMap_CZSK = LeafletMap.extend({
	getLayers:OSMczsk
});
/**
 * @alias Ptx.maps.OSM_CZSKEdit
 */
export const LeafletMapEdit_CZSK = LeafletMapEdit.extend({
	getLayers:OSMczsk
});
/**
 * @alias Ptx.maps.OSM_WORLD
 */
export const LeafletMap_WORLD = LeafletMap.extend({
	getLayers:OSMworld
});
/**
 * @alias Ptx.maps.OSM_WORLDEdit
 */
export const LeafletMapEdit_WORLD = LeafletMapEdit.extend({
	getLayers:OSMworld
});
